import { render, staticRenderFns } from "./RemoteSelectInputBase.vue?vue&type=template&id=6225f044&scoped=true"
import script from "./RemoteSelectInputBase.vue?vue&type=script&lang=js"
export * from "./RemoteSelectInputBase.vue?vue&type=script&lang=js"
import style0 from "./RemoteSelectInputBase.vue?vue&type=style&index=0&id=6225f044&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6225f044",
  null
  
)

export default component.exports